var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex flex-column fill-height"},[(!_vm.isShowRoomMode)?[_c('location-status-component')]:_vm._e(),_c('library-component'),_c('category-menu-component'),_c('language-dialog-component')],2)}
var staticRenderFns = []

export { render, staticRenderFns }